"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$text, _theme$palette2, _theme$palette2$text, _theme$palette3, _theme$palette3$prima;

  return {
    title: {
      fontSize: "1.25rem",
      fontWeight: theme.typography.fontWeightBold,
      lineHeight: 1.3,
      marginBottom: theme.spacing(2)
    },
    tabs: {
      marginBottom: theme.spacing(4)
    },
    tab: {},
    tabActive: {},
    item: {
      marginBottom: theme.spacing(1),
      "&:last-child": {
        marginBottom: 0
      }
    },
    link: {
      color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$text = _theme$palette.text) === null || _theme$palette$text === void 0 ? void 0 : _theme$palette$text.secondary,
      cursor: "pointer",
      display: "block",
      transition: theme.transitions.create("color", {
        duration: theme.transitions.duration.shorter
      }),
      "& span": {
        fontSize: "1.25rem",
        fontWeight: theme.typography.fontWeightMedium
      },
      "&:hover": {
        color: (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : (_theme$palette2$text = _theme$palette2.text) === null || _theme$palette2$text === void 0 ? void 0 : _theme$palette2$text.primary
      }
    },
    linkActive: {
      color: "".concat((_theme$palette3 = theme.palette) === null || _theme$palette3 === void 0 ? void 0 : (_theme$palette3$prima = _theme$palette3.primary) === null || _theme$palette3$prima === void 0 ? void 0 : _theme$palette3$prima.main, " !important"),
      "& span": {
        fontWeight: theme.typography.fontWeightBold
      }
    }
  };
});
var _default = styles;
exports.default = _default;